import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ValueTransformer } from '@angular/compiler/src/util';

@Component({
  selector: 'rd-notation',
  template: `<div class="notationContainer {{color}}Star" [style.fontSize.px]="size" (mouseleave)="resetNote()">
  <span class="starSpan" *ngFor="let star of starValue; let i = index"
   (click)="getNote(i)" (mouseenter)="hoverNote(i)">
    <i [class]="star"></i>
  </span>
</div>
`,
  styles: [`.notationContainer{--main-color:#ba9e5a}.notationContainer .starSpan{color:var(--main-color);cursor:pointer}.notationContainer.blueStar{--main-color:#5a5aba}.notationContainer.greenStar{--main-color:#72ba5a}.notationContainer.blue-lightStar{--main-color:#5aa2ba}.notationContainer.redStar{--main-color:#ba5a5a}.notationContainer.purpleStar{--main-color:#a25aba}.notationContainer.orangeStar{--main-color:#ba8a5a}.notationContainer.blackStar{--main-color:black}`]
})
export class RDNotationComponent implements OnInit {

  @Input() number = 5;
  @Input() value = 0;
  @Input() color = 'gold';
  @Input() size = 20;

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('stars') stars;

  private savedValue = -1;

  constructor() { }

  ngOnInit() {
  }

  get starValue() {
    const star = [];
    let iterator = 0;
    for (; iterator < this.value; iterator++) {
      star.push('fas fa-star');
    }
    for (; iterator < this.number; iterator++) {
      star.push('far fa-star');
    }
    return star;
  }

  getNote(index) {
    this.savedValue = index + 1;
    this.value = index + 1;
    this.valueChange.emit(this.value);
  }

  hoverNote(index) {
    if (this.savedValue === -1) {
      this.savedValue = this.value;
    }
    this.value = index + 1;
  }

  resetNote() {
    if (this.savedValue !== -1) {
      this.value = this.savedValue;
      this.savedValue = -1;
    }
  }

}
